import { useState } from "react";
import { Link } from "react-router-dom";
import Helmet from "react-helmet";
import { useLoginMutation } from "generated/graphql";
import AuthHeader from "components/auth/AuthHeader";
import InputField from "components/auth/InputField";
import { AuthFormWrapper, Error } from "components/auth/shared";
import { submitLoginForm } from "./functions";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";


function LoginPage(props: any) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errMsg, setErrMsg] = useState<string | undefined>(undefined);
  const [loginMutation, { loading, error }] = useLoginMutation();

  return (
    <>
      <Helmet>
        <title>Login — Jiwe eSports</title>
      </Helmet>
      <AuthHeader />
      <AuthFormWrapper>
        <h1>Log In to Jiwe eSports</h1>
        <p>
          Not a member? <Link to="/auth/register">Sign Up</Link>
        </p>
        <p>
          Forgot Password? <Link to="/auth/forgot-password">Reset Password</Link>
        </p>
        {errMsg && <Error>{errMsg}</Error>}
        <form
          onSubmit={(event) => {
            event.preventDefault();
            submitLoginForm({
              email,
              password,
              loginMutation,
              error,
              setErrMsg,
              next:
                props.location.state && props.location.state.from
                  ? props.location.state.from.pathname
                  : "/tournaments",
            });
          }}
        >
          <InputField
            setValue={setEmail}
            value={email}
            placeholder="name@email.com"
            type="email"
            name="email"
            label="Email"
            className="input-box"
          />
          <InputField
            setValue={setPassword}
            value={password}
            placeholder="6+ Characters"
            type="password"
            name="password"
            label="Password"
            className="input-box"
          />
          <button type="submit" className="btn" disabled={loading}>
            {!loading && "Log In"}
            {loading && (
              <Loader type="Bars" color="#fff" height={26} width={50} />
            )}
          </button>
          <br />
          {/* <AuthFooter
            buttonText="Log In with Google"
            loading={false}
            loggingIn={false}
          /> */}
        </form>
      </AuthFormWrapper>
    </>
  );
}

export default LoginPage;
